import React from 'react';
import EnviandoMensaje from '../assets/images/enviando_mensaje.gif';

const VentanaModalFormulario = ({ isOpen }: { isOpen: boolean }) => {

  return (
    <div
      className={`fixed inset-0 flex flex-col items-center justify-center z-50 ${
        isOpen ? 'block' : 'hidden'
      }`}
    >
        <div className="fixed inset-0 bg-black opacity-50" onClick={(e) => e.preventDefault()}></div>     
        <div className="flex flex-row flex-wrap justify-center items-center border-2 border-vp-azul rounded-lg bg-white p-2 z-50 shadow-sm shadow-vp-azul">
          <img src={EnviandoMensaje} className="w-[100px] h-[100px]" alt="Enviando mensaje" />
          <p className="font-metropolis font-regular">Enviando correo electrónico...</p>
        </div>
      </div>
  );
};

export default VentanaModalFormulario;